export function CEB_COLOR(str) {
  return `var(--COLOR_${str})`;
}

export function CEB_COLOR_RGBA(str, alpha = 1) {
  return `color-mix(in srgb, var(--COLOR_${str}) ${alpha * 100}%, transparent)`;
}
